export default function PageHeader({ eyebrow, title, intro, testid }) {
  return (
    <div className="max-w-3xl" data-testid={testid || "page-header"}>
      {eyebrow && (
        <div className="text-[10px] tracking-[0.32em] uppercase text-[#737373] mb-5">
          {eyebrow}
        </div>
      )}
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-[1.02]">
        {title}
      </h1>
      {intro && (
        <p className="text-base text-[#A3A3A3] mt-6 leading-relaxed max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
}
